import { Private_Routes } from '@common/url';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { theme } from '@prophecy/theme';
import { Stack, StackItem, Text, Ellipsis } from '@prophecy/ui-v3';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { ViewSchema } from '../../../generic-components/SchemaTable/ViewSchema';
import { StructType } from '../../../schema/sparkTypes';
import { DatasetInfoSchema, DatasetReadSchema } from '../config/dataset';
import { InfoEntity } from './EntityInfo';

type Props = {
  readOnly?: boolean;
  schema: StructType;
  projectID: string;
  format: string;
  path: string;
  branch?: string;
  isLoading: boolean;
};

const StyledInfoEntity = styled(InfoEntity)`
  height: auto;
` as typeof InfoEntity;

const StyledStackItem = styled(StackItem)`
  height: 100%;
  overflow: auto;
`;

export default function DatasetInfo({ readOnly, schema, projectID, format, path, isLoading, branch }: Props) {
  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.Dataset.home.url>>();
  const uid = decodeURIComponent(params.uid as string);
  return (
    <Stack height='100%' align='space-between'>
      <StyledStackItem grow='1'>
        <Stack height='100%' align='space-between'>
          <Stack direction='horizontal' gap={theme.spaces.x40} width='100%' align='space-between'>
            <Stack gap={theme.spaces.x24}>
              <InfoEntity
                readOnly={readOnly}
                hasCodegenContext={false}
                schema={DatasetInfoSchema()}
                variables={{ uid }}
                branch={branch}
                hideFooter={true}
                projectId={projectID}
              />
            </Stack>
            <Stack gap={theme.spaces.x12} width='60%'>
              <Stack gap={theme.spaces.x6}>
                <Text level='xs'>Format</Text>
                <Text level='sm'>{format}</Text>
              </Stack>
              <Stack gap={theme.spaces.x6}>
                <Text level='xs'>Location</Text>
                <Ellipsis tooltip={true}>
                  <Text level='sm'>{path}</Text>
                </Ellipsis>
              </Stack>
            </Stack>
          </Stack>
          <StackItem grow='1'>
            <Stack height='100%' width='100%' gap={theme.spaces.x12}>
              <Text level='xs'>Schema</Text>
              <ViewSchema disableColumnMetadata={true} loading={isLoading} schema={schema} />
            </Stack>
          </StackItem>
        </Stack>
      </StyledStackItem>
      <StyledInfoEntity
        schema={DatasetReadSchema()}
        variables={{ uid }}
        branch={branch}
        hasCodegenContext={false}
        projectId={projectID as string}
        readOnly={readOnly}
      />
    </Stack>
  );
}
